'use strict';

(function () {
  const productInfo = document.querySelector('product-info');

  if (!productInfo) {
    return;
  }

  let bundles = {};
  let subscriptionProcessed = false;
  let bundlesProcessed = false;

  let subscriptionDiscount = 0;
  let subscription = {};

  let subscriptionSelectElement = null;

  const productPrice = productInfo.dataset.price ? parseInt(productInfo.dataset.price) : 0;

  function combineBundlesAndSubscription() {
    if (!subscriptionProcessed || !bundlesProcessed) {
      return;
    }
    const oneTimeSubscription = subscription['one-time'];
    const subscriptionSubscription = subscription['subscription'];

    if (!oneTimeSubscription || !subscriptionSubscription) {
      return;
    }

    const maxSubscriptionDiscount = getMaxSubscriptionDiscountValue();

    maybeCreateQuantityInput();

    //hide one-time price
    oneTimeSubscription.wrapper.querySelector('.appstle_one_time_price_wrapper')?.style.setProperty('display', 'none');

    //hide subscription price
    subscriptionSubscription.wrapper
      .querySelector('.appstle_subscription_amount_wrapper')
      ?.style.setProperty('display', 'none');

    //update subscription discount text
    if (maxSubscriptionDiscount > 0) {
      subscriptionSubscription.wrapper
        .querySelector('.appstle-save-badge')
        ?.setAttribute('data-max-discount', `up to ${Math.round(maxSubscriptionDiscount * 100)}% off`);
    }

    if (bundles['one-time']?.length !== 0) {
      oneTimeSubscription.optionInner.insertBefore(createBundleRadios(), oneTimeSubscription.optionInner.firstChild);
    }

    if (bundles['subscription']?.length !== 0) {
      subscriptionSubscription.optionInner.insertBefore(
        createBundleRadios(true),
        subscriptionSubscription.optionInner.firstChild
      );
    }

    const bundlesAndSubscriptionOptions = document.querySelectorAll('.bundles-and-subscription__option');

    bundlesAndSubscriptionOptions.forEach((option, index) => {
      const quantity = option.dataset.quantity ? parseInt(option.dataset.quantity) : 0;

      option.addEventListener('click', () => {
        bundlesAndSubscriptionOptions.forEach((el) => {
          if (el === option) {
            return;
          }
          el.classList.remove('selected');
        });

        option.classList.add('selected');

        updateQuantity(quantity);

        if (option.closest('.appstle_include_dropdown')) {
          updateDeliverySelectOptionText(option.dataset.discountValue);
        }
      });
    });

    updateDeliverySelectOptionText(Math.round(calculateDiscount(1, true) * 100));

    // if (bundles['subscription'] && bundles['subscription'].length > 0 && ) {

    onElementClassChanged(oneTimeSubscription.wrapper, (classList) =>
      resetBundleRadiosOnAppstleChange(classList, oneTimeSubscription)
    );
    onElementClassChanged(subscriptionSubscription.wrapper, (classList) =>
      resetBundleRadiosOnAppstleChange(classList, subscriptionSubscription)
    );

    // reflect main add to cart button
    const mainAddToCartButton = document.querySelector('product-info .product-form__submit');
    if (mainAddToCartButton) {
      reflectAddToCartButton('Add to cart', oneTimeSubscription, mainAddToCartButton);
      reflectAddToCartButton('Subscribe', subscriptionSubscription, mainAddToCartButton);
    }
  }

  function updateDeliverySelectOptionText(discount) {
    if (!subscriptionSelectElement || !subscriptionSelectElement.options) {
      return;
    }

    for (const option of subscriptionSelectElement.options) {
      option.textContent = option.textContent.replace(/(\d+)%/, `${discount}%`);
    }
  }

  function maybeCreateQuantityInput() {
    if (document.querySelector('.product-form input[name="quantity"]')) {
      return;
    }

    const productFormId = getProductFormId();

    if (!productFormId) {
      return;
    }

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'quantity';
    input.id = 'bundles-and-subscription-quantity';
    input.value = 1;

    document.getElementById(productFormId).appendChild(input);
  }

  function updateQuantity(quantity) {
    const quantityInput = document.querySelector('.product-form input[name="quantity"]');

    if (!quantityInput) {
      return;
    }

    quantityInput.value = quantity;
  }

  function getProductFormId() {
    return document.querySelector('.product-form .form')?.getAttribute('id');
  }

  function resetBundleRadiosOnAppstleChange(classList, target) {
    const isActive = classList.contains('appstle-active-option');

    if (!isActive) {
      return;
    }

    target.option.querySelector('.bundles-and-subscription__option').click();
  }

  function createBundleRadios(applySubscriptionDiscount = false) {
    const discountType = applySubscriptionDiscount ? 'subscription' : 'one-time';
    const _bundles = bundles[discountType];

    const wrapper = document.createElement('div');
    wrapper.className = 'bundles-and-subscription';
    wrapper.setAttribute('role', 'radiogroup');

    wrapper.innerHTML = _bundles.reduce((html, bundle, index) => {
      const { quantity } = bundle;
      const discount = calculateDiscount(quantity, applySubscriptionDiscount);
      const price = (quantity * productPrice * (1 - discount)) / 100;

      const quantityText = `${quantity} ${pluralize(quantity, 'Pack', 'Packs')}`;
      const priceText = `<span class="bundles-and-subscription__option__price">
      ${price.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${window.cart.currency.iso_code}
      </span>`;
      const discountText =
        discount <= 0
          ? ''
          : `<span class="bundles-and-subscription__option__discount">(${Math.round(discount * 100)}% off)</span>`;

      return `${html}
        <div class="bundles-and-subscription__option ${
          index === 0 ? 'selected' : ''
        }" data-quantity="${quantity}" role="radio" data-discount-value="${Math.round(discount * 100)}">
            <span class="appstle_circle">
            <span class="appstle_dot"></span>
            </span>
            <span class="bundles-and-subscription__option__title">
              <span>${quantityText} – ${priceText} </span> ${discountText}
            </span>
        </div>
          `;
    }, '');

    return wrapper;
  }

  function calculateDiscount(quantity, applySubscriptionDiscount = false) {
    const discountType = applySubscriptionDiscount ? 'subscription' : 'one-time';

    const bundleDiscount = bundles[discountType].find((bundle) => bundle.quantity === quantity)?.discount || 0;
    const _subscriptionDiscount = applySubscriptionDiscount ? subscriptionDiscount : 0;

    return 1 - (1 - _subscriptionDiscount) * (1 - bundleDiscount);
  }

  function getMaxSubscriptionDiscountValue() {
    if (bundles['subscription'].length === 0) {
      return 0;
    }

    const maxBundleDiscount = bundles['subscription'].reduce((max, bundle) => Math.max(max, bundle.discount), 0);

    return 1 - (1 - subscriptionDiscount) * (1 - maxBundleDiscount);
  }

  function parseDiscountText(text) {
    const match = text.match(/(\d+)%/);
    return match ? parseInt(match[1], 10) / 100 : 0;
  }

  function parseQuantityDiscountText(text) {
    let quantity = null;
    let discount = null;

    const regex = /\d+%?/g;
    const matches = text.match(regex);

    if (matches) {
      matches.forEach((match) => {
        if (match.includes('%')) {
          discount = parseFloat(match.replace('%', '')) / 100;
        } else {
          if (quantity === null) {
            quantity = parseInt(match, 10);
          }
        }
      });
    }

    return { quantity, discount };
  }

  function reflectAddToCartButton(text, subscription, mainAddToCartButton) {
    const target = document.createElement('div');
    target.classList.add('reflected-add-to-cart-button-wrapper');

    subscription.optionInner.appendChild(target);

    const mutationObserver = new MutationObserver((entries) => {
      onMutation();
    });

    mutationObserver.observe(mainAddToCartButton, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    function onMutation() {
      const cloned = cloneAddToCartButton(mainAddToCartButton, text, target);

      cloned.addEventListener('click', () => {
        mainAddToCartButton.click();
      });
    }

    onMutation();
  }

  function cloneAddToCartButton(mainAddToCartButton, text, target) {
    const clonedButton = mainAddToCartButton.cloneNode(true);
    clonedButton.removeAttribute('id');
    clonedButton.removeAttribute('type');
    clonedButton.removeAttribute('name');
    clonedButton.removeAttribute('mr-click');
    clonedButton.classList.add('clone');

    clonedButton.classList.add('.reflected-main-add-to-cart-button');

    if (clonedButton.querySelector('span')) {
      clonedButton.querySelector('span').textContent = text;
    }

    target.innerHTML = '';
    target.appendChild(clonedButton);

    return clonedButton;
  }

  function parseDiscountType(text) {
    const regex = /type=([\w-]+)/;
    const match = text.match(regex);
    return match ? match[1] : null;
  }
  //subscription
  waitForElement(
    (parent, target) => {
      const subscriptionDiscountElement = target.querySelector('.appstle-save-badge');

      if (subscriptionDiscountElement) {
        subscriptionDiscount = parseDiscountText(subscriptionDiscountElement.innerText);
      }

      const subscriptionOptionWrappers = target.querySelectorAll('.appstle_subscription_wrapper_option');

      if (!subscriptionOptionWrappers || !subscriptionOptionWrappers.length) {
        return;
      }

      subscriptionSelectElement = target.querySelector('.appstle_include_dropdown .appstle_select');

      for (const subscriptionWrapper of subscriptionOptionWrappers) {
        let subscriptionOption = subscriptionWrapper.querySelector('.appstle_subscribe_option');
        const subscriptionType = subscriptionWrapper.querySelector('.appstle_one_time_details_wrapper')
          ? 'one-time'
          : 'subscription';

        if (!subscriptionOption) {
          subscriptionOption = document.createElement('div');
          subscriptionOption.classList.add('appstle_subscribe_option');

          if (!subscriptionWrapper.classList.contains('appstle-active-option')) {
            subscriptionOption.classList.add('appstle_hide_subsOption');
          }

          const subscriptionOptionInner = document.createElement('div');
          subscriptionOptionInner.className = 'appstle_subscribe_option_grid';

          const subscriptionOptionSpacer = document.createElement('div');

          subscriptionOption.appendChild(subscriptionOptionInner);
          subscriptionOption.appendChild(subscriptionOptionSpacer);
          subscriptionWrapper.appendChild(subscriptionOption);

          onElementClassChanged(subscriptionWrapper, (classList) => {
            const isActive = classList.contains('appstle-active-option');

            subscriptionOption.classList.toggle('appstle_hide_subsOption', !isActive);
          });
        }

        subscription[subscriptionType] = {
          wrapper: subscriptionWrapper,
          option: subscriptionOption,
          optionInner: subscriptionOption.querySelector('.appstle_subscribe_option_grid'),
        };
      }

      subscriptionProcessed = true;
      combineBundlesAndSubscription();
    },
    '.product',
    '.appstle_sub_widget .appstle_subscription_wrapper'
  );

  //bundles
  waitForElement(
    (parent, target) => {
      const discountedPriceItems = target
        .closest('#volumeDiscountContainer')
        ?.querySelectorAll('.ab-volume-discount-item');

      if (!discountedPriceItems || !discountedPriceItems.length) {
        return;
      }

      for (const discountedPriceItem of discountedPriceItems) {
        const volumeDiscountElements = discountedPriceItem.querySelectorAll('.ab-volume-discount');

        if (!volumeDiscountElements || !volumeDiscountElements.length) {
          continue;
        }

        const discountTypeText = discountedPriceItem.querySelector('.ab-volume-description')?.textContent;

        if (!discountTypeText) {
          continue;
        }

        const discountType = parseDiscountType(discountTypeText);
        bundles[discountType] = [];

        volumeDiscountElements.forEach((volumeDiscountElement) => {
          const quantityDiscountText = volumeDiscountElement.querySelector('.ab-volume-main-text')?.textContent;

          if (!quantityDiscountText) {
            return;
          }

          const { quantity, discount } = parseQuantityDiscountText(quantityDiscountText);
          bundles[discountType].push({
            quantity,
            discount,
          });
        });

        if (bundles[discountType].findIndex((bundle) => bundle.quantity === 1) == -1) {
          bundles[discountType].push({
            quantity: 1,
            discount: 0,
          });
        }

        bundles[discountType].sort((a, b) => a.quantity - b.quantity);
      }

      bundlesProcessed = true;
      combineBundlesAndSubscription();
    },
    '.product',
    '.ab-volume-discount-item'
  );
})();
